import { apiClient } from './client';

export interface InviteInfo {
  email: string;
  full_name: string;
  country: string;
  min_required_contribution_cents: number;
  hours_remaining: number;
  locale: string;
  locale_bootstrap?: { // S37: Server-provided locale with source
    locale: string;
    locale_source: string;
  };
}

export interface AcceptInviteRequest {
  code: string;
  password: string;
  password_confirmation: string;
}

export interface AcceptInviteResponse {
  message: string;
  user: {
    id: string;
    email: string;
    full_name: string;
    role: string;
  };
}

export const inviteEndpoints = {
  // Get invite info by code (public)
  getInfo: (code: string) =>
    apiClient.get<InviteInfo>(`/api/invite/accept?code=${encodeURIComponent(code)}`),

  // Accept invite (public)
  accept: (data: AcceptInviteRequest) =>
    apiClient.post<AcceptInviteResponse>('/api/invite/accept', data),
};
